import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LOADER_CONTEXT } from '../../../../services/interceptors/loader.interceptor';
import { FieldOperationsListResponse } from './field-operations-api.types';
import { DevicesPayload } from '../../devices/components/devices.models';

@Injectable({ providedIn: 'root' })
export class FieldOperationsApiService {
  private readonly httpClient = inject(HttpClient);

  readList(payload: DevicesPayload): Observable<FieldOperationsListResponse> {
    return this.httpClient.post<FieldOperationsListResponse>('/api/field-operations', payload, {
      context: new HttpContext().set(LOADER_CONTEXT, true)
    });
  }
}
